'use client';

import { ReactNode, useEffect } from 'react';

type WidgetsLayoutProps = {
  children: ReactNode;
};

export default function WidgetsLayout({ children }: WidgetsLayoutProps) {
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.borderBoxSize?.length > 0) {
          const height = entry.contentRect.height;
          window.parent.postMessage({ type: 'resize', height }, '*');
        }
      }
    });

    if (document.documentElement) {
      resizeObserver.observe(document.documentElement);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return <>{children}</>;
}
